const BUCKET_LABELS = {
  behavior: 'Behavior',
  food: 'Food',
  sleep: 'Sleep',
  medication: 'Medication',
  medication_context: 'Medication context',
  mood: 'Mood',
  activity: 'Activity',
  health: 'Health',
  school: 'School',
  sensory: 'Sensory',
  environment: 'Environment',
  people: 'People',
  other: 'Other',
};

const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

const compactLabel = (value) => normalizeText(value).replace(/_/g, ' ');

const normalizeBucketType = (bucket = {}) => normalizeText(
  bucket.bucket
  || bucket.bucketType
  || bucket.type
  || bucket.key
  || ''
).toLowerCase();

const normalizeStoryBucket = (bucket = {}, index = 0) => {
  const bucketType = normalizeBucketType(bucket) || `detail-${index}`;
  const summary = normalizeText(bucket.summary || bucket.value || bucket.text || bucket.sourceText);
  const sourceText = normalizeText(bucket.sourceText);
  const label = normalizeText(bucket.label) || BUCKET_LABELS[bucketType] || compactLabel(bucketType);

  if (!summary && !sourceText && !label) {
    return null;
  }

  return {
    key: `${bucketType}-${index}`,
    bucket: bucketType,
    label,
    summary,
    sourceText,
    role: compactLabel(bucket.role || bucket.certainty || ''),
    certainty: compactLabel(bucket.certainty || ''),
    needsReview: Boolean(bucket.needsReview),
  };
};

export const getCaptureFirstMetadata = (entry = {}) => (
  entry.metadata?.captureFirst
  || entry.captureFirst
  || null
);

export const getCaptureFirstStoryBuckets = (entry = {}) => (
  Array.isArray(entry.metadata?.storyBuckets)
    ? entry.metadata.storyBuckets
    : Array.isArray(entry.storyBuckets)
      ? entry.storyBuckets
      : []
).map(normalizeStoryBucket).filter(Boolean);

export const isCaptureFirstEntry = (entry = {}) => Boolean(
  getCaptureFirstMetadata(entry)
  || getCaptureFirstMetadata(entry)?.enabled
  || entry.parserMode === 'capture_first'
  || entry.parserMode === 'capture_first_backend_ai'
  || entry.inputMode === 'capture_first'
  || entry.sourceMode === 'quick_log_capture_first'
  || entry.source?.extractedBy === 'capture_first_backend_ai'
  || entry.source?.mode === 'capture_first'
  || entry.source?.type === 'quick_log_capture_first'
);

export const buildCaptureFirstTimelineDetails = (entry = {}) => {
  const captureFirst = getCaptureFirstMetadata(entry);
  const hidePickedUpDetails = Boolean(entry.metadata?.hidePickedUpDetails);
  const storyBuckets = hidePickedUpDetails ? [] : getCaptureFirstStoryBuckets(entry);
  const reviewReasons = Array.isArray(entry.metadata?.reviewReasons)
    ? entry.metadata.reviewReasons.map(normalizeText).filter(Boolean)
    : [];

  return {
    enabled: isCaptureFirstEntry(entry),
    status: captureFirst?.status || 'captured',
    reviewLabel: captureFirst?.reviewLabel || (captureFirst?.needsReview ? 'Needs a look' : 'Details found'),
    needsReview: Boolean(captureFirst?.needsReview || reviewReasons.length || storyBuckets.some((bucket) => bucket.needsReview)),
    readyToSaveCount: Number(captureFirst?.readyToSaveCount || 0),
    needsReviewCount: Number(captureFirst?.needsReviewCount || 0),
    reviewReasons: hidePickedUpDetails ? [] : reviewReasons,
    storyBuckets,
  };
};
